import MailboxDelegations from './MailboxDelegations'

export default MailboxDelegations
